module.exports = __webpack_public_path__ + "img/2-LO7.9c4f504.jpg";